var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef } from '@angular/core';
import { ModalService } from '../../../common/services/modal.service';
import { AccountApiService } from '../../../services/account.api.service';
import { AlertifyService } from '../../../services/alertify.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ShowInfoModalComponent } from '../../hub/show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../../hub/show.info.modal/show.info.modal.provider';
import { AddSpiderEventsModalActions, AddSpiderEventsModalData } from './add.spider.events.modal.provider';
import { SchedulerApiService } from '../../../services/scheduler.api.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
var AddSpiderEvenetsModalComponent = /** @class */ (function (_super) {
    __extends(AddSpiderEvenetsModalComponent, _super);
    function AddSpiderEvenetsModalComponent(dialogRef, actions, imageService, alertify, accountApiService, schedulerApiService, visitorApiService, modalService, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.imageService = imageService;
        _this.alertify = alertify;
        _this.accountApiService = accountApiService;
        _this.schedulerApiService = schedulerApiService;
        _this.visitorApiService = visitorApiService;
        _this.modalService = modalService;
        _this.isApproved = true;
        _this.totalEvents = 0;
        _this.isFetchingMoreInfo = false;
        _this.isSaving = false;
        _this.data = data;
        _this.data.events.forEach(function (x) {
            x.events = x.events.filter(function (y) { return y.eventTimes && y.eventTimes.length; });
            x.events.forEach(function (y) { return (y.checked = true); });
            _this.totalEvents += x.events.length;
        });
        console.log(_this.data.events);
        return _this;
    }
    AddSpiderEvenetsModalComponent.prototype.setAccount = function (hubName) {
        this.data.hubName = hubName;
    };
    AddSpiderEvenetsModalComponent.prototype.toggleAll = function () {
        this.data.events.forEach(function (e) {
            e.events.forEach(function (x, i) {
                x.checked = !x.checked;
            });
        });
    };
    AddSpiderEvenetsModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    AddSpiderEvenetsModalComponent.prototype.getMoreInfo = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var e, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e = this.getEventFromModal(event);
                        e && (e.isUpdating = true);
                        return [4 /*yield*/, this.schedulerApiService
                                .eventbriteEventDetails(event.eventLink)
                                .finally(function () {
                                e.isUpdating = false;
                            })
                                .toPromise()];
                    case 1:
                        result = _a.sent();
                        if (e) {
                            e.description = result.info && result.info.description ? result.info.description : e.description;
                            if (e.multiHosts && e.multiHosts.length) {
                                e.multiHosts[0].img = result.info.hostImg;
                            }
                            e.isUpdated = true;
                            console.log('Updated', e);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AddSpiderEvenetsModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var events, eventbriteEvents, _loop_1, this_1, _i, events_1, event_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.data.hubName) {
                            event.complete();
                            alert('Please select an account.');
                            return [2 /*return*/];
                        }
                        events = [];
                        this.data.events.forEach(function (x) {
                            events.push.apply(events, x.events.filter(function (x) { return x.checked; }));
                        });
                        console.log('events count:', events.length);
                        if (!this.data.socialName.includes('eventbrite')) return [3 /*break*/, 6];
                        this.isFetchingMoreInfo = true;
                        return [4 /*yield*/, this.visitorApiService
                                .getEvents(this.data.hubName, {
                                socialName: 'eventbrite',
                                projection: '-analytics -isBlocked -blacklisted -isApproved -categories -changeHistory -customCategories -eventTimesText -isOnlineEvent -isChoice -isCustom -isFacebookEvent -isHideTicketUrl -isHubCreated -isHybridEvent -isManuallyCreated -isToBeExport -nameId -title -timestamp',
                            })
                                .toPromise()];
                    case 1:
                        eventbriteEvents = _a.sent();
                        _loop_1 = function (event_1) {
                            var exist;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        exist = eventbriteEvents.find(function (x) { return x.socialId === event_1.socialId; });
                                        if (!exist) return [3 /*break*/, 4];
                                        if (!(exist.description && !exist.description.includes('ig-eventbrite-event-full-description'))) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this_1.getMoreInfo(event_1)];
                                    case 1:
                                        _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        event_1.isUpdated = true;
                                        _a.label = 3;
                                    case 3: return [3 /*break*/, 6];
                                    case 4: return [4 /*yield*/, this_1.getMoreInfo(event_1)];
                                    case 5:
                                        _a.sent();
                                        _a.label = 6;
                                    case 6: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, events_1 = events;
                        _a.label = 2;
                    case 2:
                        if (!(_i < events_1.length)) return [3 /*break*/, 5];
                        event_1 = events_1[_i];
                        return [5 /*yield**/, _loop_1(event_1)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        this.isFetchingMoreInfo = false;
                        events = [];
                        this.data.events.forEach(function (x) {
                            events.push.apply(events, x.events.filter(function (x) { return x.checked; }));
                        });
                        _a.label = 6;
                    case 6:
                        this.isSaving = true;
                        this.accountApiService
                            .saveSpiderEvents(this.data.hubName, {
                            isApproved: this.isApproved,
                            events: events,
                            // socialName: `${this.data.socialName}${spiderSources.any((x) => x === this.data.socialName) ? '|spider' : ''}`,
                            socialName: this.data.socialName === 'facebook'
                                ? 'facebook|spider'
                                : this.data.socialName === 'eventbrite'
                                    ? 'eventbrite|internal-api'
                                    : this.data.socialName,
                        })
                            .finally(function () {
                            event.complete();
                            _this.isSaving = false;
                        })
                            .subscribe(function (result) {
                            if (result) {
                                if (result.saved.length === _this.totalEvents) {
                                    _this.alertify.successfully('Save events');
                                    _this.dialogRef.close();
                                }
                                else {
                                    var icons = [], text_1 = [];
                                    if (result.saved.length) {
                                        icons.push({ icon: 'check', color: 'green' });
                                        text_1.push(result.saved.length + " events saved successfully");
                                    }
                                    if (result.updated.length) {
                                        icons.push({ icon: 'cached', color: 'green' });
                                        text_1.push(result.updated.length + " events updated");
                                    }
                                    if (result.merged.length) {
                                        icons.push({ icon: 'list', color: 'green' });
                                        text_1.push(result.merged.length + " events merged");
                                    }
                                    if (result.existed.length) {
                                        icons.push({ icon: 'error_outline', color: 'orange' });
                                        text_1.push(result.existed.length + " events not saved due to existed");
                                    }
                                    if (result.notSaved.length) {
                                        icons.push({ icon: 'error_outline', color: 'red' });
                                        text_1.push(result.notSaved.length + " events not saved due to missing properties, please check event info and address");
                                    }
                                    if (result.approvalStatusNotChanged.length) {
                                        text_1.push("<hr style=\"width:680px;height:unset\"/>");
                                        text_1.push("<span style=\"margin-bottom: 6px\">The following events already exist and " + (_this.isApproved
                                            ? '<span style="color:red">unapproved</span>'
                                            : '<span style="color:green">approved</span>') + ", they will stay " + (_this.isApproved
                                            ? '<span style="color:red">unapproved.</span>'
                                            : '<span style="color:green">approved.</span>') + "</span>");
                                        result.approvalStatusNotChanged.forEach(function (x, i) {
                                            text_1.push("<span style=\"font-size: 14px\">" + (i + 1) + ": " + x + "</span>");
                                        });
                                    }
                                    _this.modalService.show({
                                        component: ShowInfoModalComponent,
                                        providers: [
                                            { provide: ShowInfoModalActions, useValue: null },
                                            {
                                                provide: InfoModalData,
                                                useValue: new InfoModalData('Result', icons, text_1),
                                            },
                                        ],
                                        panelClass: 'width-modal-3',
                                    });
                                }
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AddSpiderEvenetsModalComponent.prototype.getEventFromModal = function (event) {
        for (var _i = 0, _a = this.data.events; _i < _a.length; _i++) {
            var x = _a[_i];
            var e = x.events.find(function (y) { return y.socialId === event.socialId; });
            if (e)
                return e;
        }
        return null;
    };
    return AddSpiderEvenetsModalComponent;
}(BaseComponent));
export { AddSpiderEvenetsModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/add.spider.events.modal/add.spider.events.modal.component.ts.pre-build-optimizer.js